import { Vue } from 'vue-property-decorator';
import type Dialog from './dialog';
import { decoratorDispense } from '@/util';

/**
 *
 * @param component 弹窗要展示的组件
 * @param conf 传入组件的配置
 * @param singleton:boolean (default true) 是否单列弹窗
 */
export function singletonFactory<T extends Vue & Dialog>(component?: any, conf: any = {}, singleton = false): any {
  class Picker {
    static instance: T;
    static open(options = {}) {
      return new Promise<any>((res, rej) => {
        const cs = new Picker({ ...conf, ...options });
        const i = Picker.instance;
        i.$on('result', (val) => {
          res(val);
        });
        i.$on('cancel', () => {
          rej('cancel');
        });
        i.$once('hidden', () => {
          if (Picker.instance && !singleton) {
            Picker.instance.$destroy();
          }
        });
        Vue.nextTick().then(() => {
          i.dialogShow = true;
        });
      });
    }

    constructor(options = {}) {
      if (singleton) {
        if (!Picker.instance) {
          this.createInstance(options);
          return;
        }

        for (const key in options) {
          if (options.hasOwnProperty(key)) {
            const element = options[key];
            Picker.instance[key] = element;
          }
        }
      } else {
        this.destroyInstance();
        this.createInstance(options);
      }
    }

    private destroyInstance() {
      if (Picker.instance) {
        Picker.instance.$destroy();
      }
    }

    private createInstance(options = {}) {
      Picker.instance = new component({
        data: options,
      });
      const el = document.createElement('div');
      Picker.instance.$mount(el);
      document.body.append(Picker.instance.$el);
    }
  }
  return Picker as any;
}

const DialogFactory = decoratorDispense(singletonFactory);

export default DialogFactory;
